import { createContext } from 'react';
const CustomerAuthContext = createContext();
export default CustomerAuthContext;
